<div uppDataid="floor-render-root" style="width: 100%; height: 100%;">
    <upp-konva *ngIf="Konva" [model]="Konva" [active]="true" (onSelect)="OnKonvaSelect($event)" (onTransform)="OnKonvaTransform($event)"></upp-konva>
</div>
